import {CursorBasedPaginationResponse} from 'api/common';
import {Board} from './board.model';

export type BoardView = {
    active: boolean;
    board?: Board;
    boardId?: string;
    boardViewType: BoardViewTypeEnum;
    description?: string;
    id: string;
    itemView: string;
    order: number;
    title: string;
};

export enum BoardViewTypeEnum {
    Calendar = 'CALENDAR',
    Gantt = 'GANTT',
    Kanban = 'KANBAN',
    Table = 'TABLE',
    Report = 'REPORT',
    TicketUserAssignmentReport = 'TICKET_USER_ASSIGNMENT_REPORT',
}
export interface BoardViewRequest {
    boardSlug: string;
}
export interface BoardViewResponse {
    boardViews: CursorBasedPaginationResponse<BoardView>;
}

export enum ItemSummaryBuildInVariablesEnums {
    timeTrackerCounter = 'timeTrackerCounter',
    timeTrackerButtons = 'timeTrackerButtons',
}
export const myWorkBoardViewDefaultValue: BoardView = {
    active: true,
    boardId: 'my-work-board',
    boardViewType: BoardViewTypeEnum.Kanban,
    description: 'My Work Board',
    id: 'my-work',
    itemView: 'my-work-item-view',
    order: 1,
    title: 'My Work',
};
